import React from 'react';

export default function RenderHtml({ htmlContent }) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}